import React from 'react';
import PropTypes from 'prop-types';
import Preloader from '../Preloader';
import NewsCard from './NewsCard';


export default class News extends React.Component {
    static propTypes = {
        // eslint-disable-next-line
        data: PropTypes.any,
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="news--wrapper">
                {this.props.data.length > 0 ? this.props.data.map((item, index) => <NewsCard key={`news_${item._id.$id}_${(window.location.pathname.indexOf('materials') + 1 === 0) ? '_widget' : '_page'}`} {...item} className={index === 0 ? 'normal_card' : 'normal_card'} />) : <Preloader />}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Materials/News.jsx